type Bounds = Pick<DOMRect, 'left' | 'right' | 'top' | 'bottom'>;

/** The corridor between a label and its card, including a diagonal approach. */
export function isBetweenHelpSurfaces(
  x: number,
  y: number,
  trigger: Bounds,
  panel: Bounds,
): boolean {
  const upper = trigger.bottom <= panel.top ? trigger : panel.bottom <= trigger.top ? panel : null;
  if (!upper) return false;
  const lower = upper === trigger ? panel : trigger;
  const gap = lower.top - upper.bottom;
  if (gap <= 0 || y < upper.bottom || y > lower.top) return false;
  const progress = (y - upper.bottom) / gap;
  const left = upper.left + (lower.left - upper.left) * progress;
  const right = upper.right + (lower.right - upper.right) * progress;
  return x >= left - 8 && x <= right + 8;
}
